import moment from 'moment'

const MS_IN_DAY = 86400000

export default {
  to_utc(date) {
    if (date == null)
      return date
    if (date._isAMomentObject)
      date = date.toDate()
    if (typeof date === 'string')
      date = new Date(date)
    return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()))
  },
  to_local(date) {
    if (date == null)
      return date
    if (date._isAMomentObject)
      date = date.toDate()
    if (typeof date === 'string')
      date = new Date(date)
    return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate())
  },
  to_date(t) {
    return moment.utc(t).format('YYYY-MM-DD')
  },
  to_date_short(t) {
    const obj = moment.utc(t)
    if (obj.year() === moment.utc().year())
      return obj.format('MM-DD')
    return obj.format('YY-MM-DD')
  },
  to_date_cn(t) {
    return moment.utc(t).format('YYYY年MM月DD日')
  },
  to_datetime(t) {
    return moment.utc(t).local().format('YYYY-MM-DD HH:mm:ss')
  },
  to_datetime_short(t) {
    return moment.utc(t).local().format('YY-MM-DD/HH:mm')
  },
  to_datetime_cn(t) {
    return moment.utc(t).local().format('YYYY年MM月DD日 HH:mm:ss')
  },
  expiring_text_from_now(t) {
    // The next day at 12:00 am
    const time = moment.utc(t).local().startOf('days')
    const today = moment().startOf('days')
    const days = time.diff(today, 'days')
    if (days === 0)
      return '今天'
    if (days === -1)
      return '昨天'
    if (days === 1)
      return '明天'
    return time.fromNow()
  },
  expiring_days_from_now(t) {
    // The next day at 12:00 am
    const time = moment.utc(t).local().startOf('days')
    const today = moment().startOf('days')
    return time.diff(today, 'days') + 1
  },
  days_from_now(t) {
    // The next day at 12:00 am
    const time = moment.utc(t).local().startOf('days')
    const today = moment().startOf('days')
    return time.diff(today, 'days')
  },
  from_now(t) {
    if (!t)
      return '从未'
    return moment.utc(t).local().locale('zh-cn').fromNow()
  },
  days_in_between(a, b) {
    return Math.round((a - b) / MS_IN_DAY)
  },
  months_in_between(a, b) {
    let month = 0
    month += (a.year() - b.year()) * 12
    month += (a.month() - b.month())
    return month
  },
}



// WEBPACK FOOTER //
// ./modules/formatters/date.js